"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormMigrateModal = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const input_state_1 = require("../../components/input/input.state");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const store_1 = require("../../store");
const collection_form_migrate_modal_ctrl_1 = require("./collection.form.migrate.modal.ctrl");
const collection_form_migrate_modal_style_1 = require("./collection.form.migrate.modal.style");
(0, theme_1.addStyles)(collection_form_migrate_modal_style_1.Style);
class CollectionFormMigrateModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, collections) {
        super(ctx);
        this.departmentForms = [];
        this.errors = [];
        this.selectedFormRevision = null;
        this.ctrl = new collection_form_migrate_modal_ctrl_1.CollectionFormMigrateModalCtrl(collections);
        this.errorState = new input_state_1.InputState(i18n_1.T.ERROR);
        this.loadingState = new input_state_1.InputState(i18n_1.T.LOADING);
        this.addState(this.errorState);
        this.addState(this.loadingState);
        store_1.AppStore.FormSummary.refresh();
    }
    get nodes() {
        var _a;
        this.departmentForms = store_1.AppStore.FormSummary.all;
        if (this.departmentForms.length === 0) {
            this.loadingState.setError(i18n_1.T.LOADING);
            return spinner_1.Spinner.view();
        }
        const collectionFormRevision = (_a = this.ctrl.collections[0]) === null || _a === void 0 ? void 0 : _a.formRevision;
        const filteredForms = this.departmentForms.filter((form) => form.metadata &&
            (form.metadata.ocalc ||
                form.metadata.spidacalc ||
                form.metadata.poleforeman ||
                form.metadata.ikePoleForeman ||
                form.metadata.dds) &&
            form.revision !== collectionFormRevision);
        if (filteredForms.length === 0) {
            return (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_NO_FORMS));
        }
        this.loadingState.reset();
        if (!this.selectedFormRevision) {
            this.selectedFormRevision = filteredForms[0].revision;
        }
        return (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.content }, [
                (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.warningTitle }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE)),
                (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.warningBody }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1)),
                (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.body }, [
                    (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2)),
                    (0, mithril_1.m)('ul', [
                        (0, mithril_1.m)('li', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3)),
                        (0, mithril_1.m)('li', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4)),
                    ]),
                    (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY)),
                ]),
            ]),
            (0, mithril_1.m)('select', {
                onchange: (e) => {
                    if ('target' in e && e.target && 'value' in e.target && typeof e.target.value === 'string') {
                        this.selectedFormRevision = e.target.value;
                    }
                },
            }, filteredForms.map((form) => (0, mithril_1.m)('option', { value: form.revision }, `${form.displayname} (V${form.displayversion})`))),
        ]);
    }
    failToChange() {
        this.errors = this.ctrl.failures;
        this.errorState.setError(i18n_1.T.ERROR);
        notification_service_1.NotificationService.error({ key: i18n_1.T.COLLECTION_MIGRATE_FORM_FAIL });
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.selectedFormRevision) {
                yield this.ctrl.updateFormCollections(this.selectedFormRevision);
            }
        });
    }
}
exports.CollectionFormMigrateModal = CollectionFormMigrateModal;
tslib_1.__decorate([
    mobx_1.observable
], CollectionFormMigrateModal.prototype, "errors", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CollectionFormMigrateModal.prototype, "selectedFormRevision", void 0);
//# sourceMappingURL=collection.form.migrate.modal.js.map